<template>
  <div class="landing-page-wrapper">
    <div class="landingpage-bg">
      <img class="img-landingpage-bg" src="../../../../assets/img/landingpage-bg.png" alt="" />
    </div>
    <div class="landing-top-container">
      <div class="landing-logo">
        <img src="../../../../assets/img/isupplier-logo.png" class="img-landing-logo" alt="" />
      </div>
      <div class="landing-right-form">
        <select class="mr-sm-2" id="badan_usaha" v-model="selectedBidangUsaha" :disabled="isEdit">
          <option disabled="disabled" style="color: grey; font-size: 10px;">Bidang Usaha</option>
          <option selected="selected" value="1">Badan Usaha</option>
          <option value="2">Perorangan</option>
        </select>

        <select class="mr-sm-2" id="tipe_pendaftaran" v-model="selectedTipePendaftaran" :disabled="isEdit">
          <option disabled="disabled" style="color: grey; font-size: 10px;">Tipe Pendaftaran</option>
          <option selected="selected" value="1">Nasional</option>
          <option value="2">Internasional</option>
          <option value="3">Khusus/Vendor Memo</option>
        </select>
        <button v-if="!isEdit" class="mb-2 btn-button" @click="() => isEdit = true">Edit</button>
        <button v-else-if="isEdit" class="mb-2 btn-button" @click="() => isEdit = false">Done</button>
      </div>

    </div>
    <div class="landing-container">
      <div class="landing-right">
        <div class="step-indicator">
          <div class="step-wrapper">
            <div :class="$store.state.landingpage.activeLanding == 'instruction'
              ? 'step-number-white'
              : 'step-number-red'
              " @click="jumpTo('instruction')">
              1
            </div>
            <div class="step-hr-start"></div>
            <div class="step-name">Registrasi</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('profiles')" :class="$store.state.landingpage.activeLanding == 'profile' ||
              $store.state.landingpage.activeLanding == 'profilebu'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              2
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Profil</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('alamat')" :class="$store.state.landingpage.activeLanding == 'alamat' ||
              $store.state.landingpage.activeLanding == 'alamatbu'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              3
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Alamat</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('bank')" :class="$store.state.landingpage.activeLanding == 'bank' ||
              $store.state.landingpage.activeLanding == 'bankbu'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              4
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Bank</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('afiliasi')" :class="$store.state.landingpage.activeLanding == 'afiliasi' ||
              $store.state.landingpage.activeLanding == 'afiliasibu'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              5
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Afiliasi</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('legaldoc')" :class="$store.state.landingpage.activeLanding == 'legalitas' ||
              $store.state.landingpage.activeLanding == 'legalitasbu'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              6
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Dokumen Legal</div>
          </div>
          <div class="step-wrapper">
            <div @click="jumpTo('selesai')" :class="$store.state.landingpage.activeLanding == 'selesai'
              ? 'step-number-white'
              : 'step-number-red'
              ">
              7
            </div>
            <div class="step-hr-end"></div>
            <div class="step-name">Selesai</div>
          </div>
        </div>
        <div class="landing-form">
          <!-- Badan Usaha - Nasional -->
          <div v-if="selectedBidangUsaha === '1' && selectedTipePendaftaran === '1'" class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" :isEdit="isEdit">
              </component>
            </keep-alive>
          </div>

          <!-- Badan Usaha - Internasional -->
          <div v-if="selectedBidangUsaha === '1' && selectedTipePendaftaran === '2'" class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" :isEdit="isEdit" />
            </keep-alive>
          </div>

          <!-- Badan Usaha - Khusus / Vendor Memo -->
          <div v-if="selectedBidangUsaha === '1' && selectedTipePendaftaran === '3'" class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" :isEdit="isEdit" />
            </keep-alive>
          </div>

          <!-- Perorangan - Nasional -->
          <div v-if="selectedBidangUsaha === '2' && selectedTipePendaftaran === '1'" class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" :isEdit="isEdit" />
            </keep-alive>
          </div>

          <!-- Perorangan - Internasional -->
          <div v-if="selectedBidangUsaha === '2' && selectedTipePendaftaran === '2'" class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" :isEdit="isEdit" />
            </keep-alive>
          </div>

          <!-- Perorangan - Khusus/Vendor Memo -->
          <div v-if="selectedBidangUsaha === '2' && selectedTipePendaftaran === '3'" class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" :isEdit="isEdit" />
            </keep-alive>
          </div>

        </div>
      </div>
    </div>
    <div class="landing-footer-container">
      <span style="color:#fff; text-align:center">Copyright© {{ new Date().getFullYear() }}
        <span style="color:#fff; font-weight:bold">Sinarmas Mining</span>. All
        Rights reserved</span>
    </div>
    <GlobalLoading v-if="
      $store.state.mdLandingStore.isLoading
    " />
    <Notif v-if="$store.state.showModalNotif" />
  </div>
</template>
<script>

export default {
  name: 'instruction',
  data() {
    return {
      pick: '',
      errorMessage: null,

      selectedBidangUsaha: '1',
      selectedTipePendaftaran: '1',
      currentContent: null,
      isEdit: false,
    }
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Notif: () => import('@/components/modal/Notification.vue'),
  },
  async created() {
    const user = this.$get(this.$route, 'params.user')

    if (user) {
      await this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'userid',
        value: user,
      })
    }
  },

  computed: {
    activeLanding: function () {
      const tab = this.$store.state.landingpage.activeLanding

      switch (tab) {
        case 'instruction':
          this.$store.dispatch('mdLandingStore/getAllForms', {
            step_id: 1,
            bidang_usaha_id: this.selectedBidangUsaha,
            type_pendaftaran_id: this.selectedTipePendaftaran,
          })
          return () => import('@/views/MasterData/LandingPage/Instruction.vue')
          break
        case 'alamat':
          this.$store.dispatch('mdLandingStore/getAllForms', {
            step_id: 3,
            bidang_usaha_id: this.selectedBidangUsaha,
            type_pendaftaran_id: this.selectedTipePendaftaran,
          })
          return () => import('@/views/MasterData/LandingPage/Alamat.vue')
          break
        case 'bank':
          this.$store.dispatch('mdLandingStore/getAllForms', {
            step_id: 4,
            bidang_usaha_id: this.selectedBidangUsaha,
            type_pendaftaran_id: this.selectedTipePendaftaran,
          })
          return () => import('@/views/MasterData/LandingPage/Bank.vue')
          break
        case 'afiliasi':
          this.$store.dispatch('mdLandingStore/getAllForms', {
            step_id: 5,
            bidang_usaha_id: this.selectedBidangUsaha,
            type_pendaftaran_id: this.selectedTipePendaftaran,
          })
          return () => import('@/views/MasterData/LandingPage/Afiliasi.vue')
          break
        case 'profilebu':
          this.$store.dispatch('mdLandingStore/getAllForms', {
            step_id: 2,
            bidang_usaha_id: this.selectedBidangUsaha,
            type_pendaftaran_id: this.selectedTipePendaftaran,
          })
          return () => import('@/views/MasterData/LandingPage/ProfilBU.vue')
          break
        case 'legalitasbu':
          if (this.selectedBidangUsaha == 1) {
            this.$store.dispatch('mdLandingStore/getAllForms', {
              step_id: 6,
              bidang_usaha_id: this.selectedBidangUsaha,
              type_pendaftaran_id: this.selectedTipePendaftaran,
            })
            return () => import('@/views/MasterData/LandingPage/LegalitasBU.vue')
          } else {
            this.$store.dispatch('mdLandingStore/getAllForms', {
              step_id: 6,
              bidang_usaha_id: this.selectedBidangUsaha,
              type_pendaftaran_id: this.selectedTipePendaftaran,
            })
            return () => import('@/views/MasterData/LandingPage/Legalitas.vue')
          }
          // this.$store.dispatch('mdLandingStore/getAllForms', {
          //   step_id: 6,
          //   bidang_usaha_id: 1,
          //   type_pendaftaran_id: this.selectedTipePendaftaran,
          // })
          // return () => import('@/views/MasterData/LandingPage/LegalitasBU.vue')
          break
        case 'selesai':
          this.$store.dispatch('mdLandingStore/getAllForms', {
            step_id: 7,
            bidang_usaha_id: this.selectedBidangUsaha,
            type_pendaftaran_id: this.selectedTipePendaftaran,
          })
          return () => import('@/views/MasterData/LandingPage/Selesai.vue')
          break
        default:
          break
      }
    },
  },
  methods: {
    jumpTo(name) {
      if (name == 'instruction') {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'instruction')
      }

      if (name == 'profiles') {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'profilebu')
      }

      if (name == 'alamat') {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'alamat')
      }
      if (name == 'bank') {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'bank')
      }
      if (name == 'afiliasi') {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'afiliasi')
      }
      if (name == 'legaldoc') {
        this.$store.commit(
          'landingpage/SET_LANDINGPAGE_FORM',
          'legalitasbu'
        )
      }
      if (name == 'selesai') {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'selesai')
      }
    },
  },
}
</script>
